import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../environments/environment';
import { UserStateService } from './features/user/services';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, ToastModule, ProgressSpinnerModule],
  template: `
    @if (!authReady()) {
      <div
        class="fixed inset-0 flex items-center justify-center bg-surface-0 z-[9999]"
      >
        <p-progressSpinner ariaLabel="Cargando..." />
      </div>
    }
    <router-outlet />
    <p-toast />
  `,
})
export class AppComponent {
  private readonly userStateService = inject(UserStateService);
  private readonly router = inject(Router);
  private readonly http = inject(HttpClient);

  authReady = this.userStateService.authReady;

  constructor() {
    this.http
      .get(`${environment.planTackApiUrl}/api/v1/health`)
      .subscribe({ error: () => undefined });
    this.userStateService.checkAuthenticationStatus().subscribe();
    this.router.initialNavigation();
  }
}
